// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"298":"cite","363":"Screenshot","728":"ToolSourceDisplay","994":"workflowLayout"}[chunkId] || chunkId) + ".bundled.js";
};